















































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import MenuManager from "@/components/MenuManager.vue";
import "@/plugins/metaHeadful";
import BannerCard from "@/components/stateless/BannerHomeCard.vue";
import SimpleBannerCard from "@/components/stateless/SimpleBannerCard.vue";
import HowToCard from "@/components/stateless/HowToCard.vue";
import MoodCard from "@/components/stateless/MoodCard.vue";
import SwiperCarousel from "@/components/SwiperCarousel.vue";
import { CellarsRequests, configService, ExperiencesRequests, UtilitiesFunctions } from "@/helpers";
import utilitiesFunctions from "@/helpers/utilitiesFunctions";
import { mapState } from 'vuex';
import { CategoryTag } from '@/models/tag';
import { acceptSuggestion, fetchSuggestions, SuggestionItem } from '@/helpers/requests/suggestions';

@Component({
    components: {
      SimpleBannerCard,
      BannerCard,
      SwiperCarousel,
      HowToCard,
      MoodCard,
      MenuManager
    },
    computed: {
      ...mapState("app", ["tagsList"])
    }
  })
  export default class Home extends Vue {
    tagsList!: CategoryTag[];
    ogImageUrl: string = configService.ogImageUrl;
    experienceHomeStyle: boolean = true;
    cellarsLoading: boolean = false;
    experiencesLoading: boolean = false;
    handleRoute = UtilitiesFunctions.handleRoute;
    howToItems: Array<any> = [];
    moodItems: Array<any> = [];
    experiencesList: Array<any> = [];
    onlineExperienceId: string = '';
    onlineExperiencesList: Array<any> = [];
    cellarsList: Array<any> = [];
    searchTerm: string = '';
    loadingSuggestions: boolean = false;
    abortCtrl!: AbortController;
    suggestion: any = '';
    suggestionItems: SuggestionItem[] = [];


experienceCarousel: any = {
      slidesPerView: 5,
      breakpoints: {
        1280: {
          slidesPerView: 5,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20
        }
      }
    };

    regionCarousel: any = {
      slidesPerView: 4,
      spaceBetween: 10,
      slides: [
        {
          image: 'assets/static/wine_region/franciacorta.jpg',
          url: '/esperienze?wineregion=334f1700-c1ab-444d-89aa-a92ccbc63b12',
          title:'Franciacorta',
          content:'Franciacorta'
        },
         {
          image: 'assets/static/wine_region/barolo.jpg',
          url: '/esperienze?wineregion=4aa30f1a-22f3-4cff-a3cf-ee9dc352f081',
          title:'Barolo',
          content:'Barolo'
        },
        {
          image: 'assets/static/wine_region/chianti.jpg',
          url: '/esperienze?wineregion=b13b601c-2d41-461b-9323-3ba19083543c',
          title:'Chianti',
          content:'Chianti'    
        },
        {
          image: 'assets/static/wine_region/amarone.jpg',
          url: '/esperienze?wineregion=6198229c-5828-44fb-8921-4e8b5ab5c4cd',
          title:'Amarone',
          content:'Amarone'     
        },
        {
          image: 'assets/static/wine_region/valtellina.jpg',
          url: '/esperienze?wineregion=11fee986-9111-4c91-af14-8266e0201dd1',
          title:'Valtellina',
          content:'Valtellina'
        },
        {
          image: 'assets/static/wine_region/langhe.jpg',
          url: '/esperienze?wineregion=4aa30f1a-22f3-4cff-a3cf-ee9dc352f081',
          title:'Langhe',
          content:'Langhe'
        },
        {
          image: 'assets/static/wine_region/bolgheri.jpg',
          url: '/esperienze?wineregion=48882d62-4bd5-48d6-9ea4-50f544c904be',
          title:'Bolgheri',
          content:'Bolgheri'
        },
        {
          image: 'assets/static/wine_region/montalcino.jpg',
          url: '/esperienze?wineregion=d099ceb9-0e6f-4b52-934b-2d73c92c4968',
          title:'Montalcino',
          content:'Montalcino'
        },
        {
          image: 'assets/static/wine_region/oltrepo.jpg',
          url: '/esperienze?wineregion=f0589db7-b87d-4e8d-adac-f6da01f2650b',
          title:'Oltrepò',
          content:'Oltrepò'
        }
      ],
      breakpoints: { // fino a xxxx, compreso
        2100: {
          slidesPerView: 4
        },
        1904: {
          slidesPerView: 4
        },
        1264: {
          slidesPerView: 3
        },
        960: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 1
        }
      }
    };
    feedbackCarousel: any = {
      slidesPerView: 6,
      spaceBetween: 60,
      slides: [
        {
          image: 'assets/static/pages/about/feedback/corriere-della-sera.png'
        },
        {
          image: 'assets/static/pages/about/feedback/startup-italia.png',
          url: 'https://startupitalia.eu/116569-20191019-nasce-divinea-la-piattaforma-online-di-turismo-enologico-esperienziale'
        },
        {
          image: 'assets/static/pages/about/feedback/gq.png',
          url: 'https://www.gqitalia.it/lifestyle/article/weekend-mete-italia-vino-cantine'
        },
        {
          image: 'assets/static/pages/about/feedback/gambero-rosso.png'
        },
        {
          image: 'assets/static/pages/about/feedback/panorama.png',
          url: 'https://mytech.panorama.it/divinea-sito-prenotare-esperienze-vino/'
        }
      ],
      breakpoints: { // fino a xxxx, compreso
        2100: {
          slidesPerView: 5
        },
        1904: {
          slidesPerView: 5
        },
        1264: {
          slidesPerView: 5
        },
        960: {
          slidesPerView: 4,
          spaceBetween: 30
        },
        600: {
          slidesPerView: 2
        }
      }
    };

    @Watch("$i18n.locale", {immediate: true, deep: true})
    onLangChanged(val: string) {
      this.setHowToItems();
    }


  @Watch('suggestion')
  onSuggestionAccepted(item: any) {
    acceptSuggestion(this.$router, item);
  }

  @Watch('searchTerm')
  onTermInput(input: string) {
    if (!input || input === this.suggestion.title) return;
    this.loadingSuggestions = true;
    this.suggestionItems = [];
    fetchSuggestions(input)
      .then(items => {
        this.loadingSuggestions = false;
        this.suggestionItems = items;
      })
      .catch(err => {
        if (err.name === 'AbortError') return;
        this.loadingSuggestions = false;
      })
  }

    onSearch() {
      this.$router.replace({
        name: 'experiences',
        query: { term: this.searchTerm }
      })
    }

    mounted() {
      this.setHowToItems();
      this.getMoodItems();
      this.getCellars();
      this.getExperiences();
    }

    created() {
      // this.openNewsletterDialog();
    }

    openNewsletterDialog() {
      const hideDialog = localStorage.getItem("hideNewsletterDialog");
      if(!hideDialog) {
        this.$store
                .dispatch("app/setDialog", {
                  type: "newsletterDialog",
                  state: true,
                })
                .then(() => {})
                .catch(error => {
                  console.error(error);
                });
      }
    }

    setHowToItems() {
      this.howToItems = [
        {
          title: this.$t("homeView.howToItemsHome.searchTitle"),
          logoUrl: require("@/assets/icons/searchHomeIcon.svg"),
          description: this.$t("homeView.howToItemsHome.searchDescription")
        },
        {
          title: this.$t("homeView.howToItemsHome.bookTitle"),
          logoUrl: require("@/assets/icons/calendarHomeIcon.svg"),
          description: this.$t("homeView.howToItemsHome.bookDescription")
        },
        {
          title: this.$t("homeView.howToItemsHome.experiencesTitle"),
          logoUrl: require("@/assets/icons/addressHomeIcon.svg"),
          description: this.$t("homeView.howToItemsHome.experiencesDescription")
        },
        {
          title: this.$t("homeView.howToItemsHome.shareTitle"),
          logoUrl: require("@/assets/icons/shareHomeIcon.svg"),
          description: this.$t("homeView.howToItemsHome.shareDescription")
        }
      ];
    }

    getMoodItems() {
      this.moodItems = utilitiesFunctions.buildMoodTags();
    }

    getExperiences() {
      const exptypeTags = this.tagsList.find(tags => tags.code == 'exptype');
      if (exptypeTags && exptypeTags.tags) {
        const onlineTag = exptypeTags.tags.find(tag => tag.code === 'smart') || {} as any;
        this.onlineExperienceId = onlineTag.id
      }
      console.log(this.tagsList);
      return Promise.all([
        ExperiencesRequests.fetchAll("per_page=25&page=1"),
        ExperiencesRequests.fetchAll(`per_page=25&page=1&experience_type_ids=${this.onlineExperienceId}`)])
              .then(([response, onlineExperiences]) => {
                this.experiencesLoading = false;
                this.experiencesList = response.data;
                this.onlineExperiencesList = onlineExperiences.data;
              })
              .catch((error: Error) => {
                this.experiencesLoading = false;
                this.$store.dispatch("app/setSnackbarMessage", {
                  message: error,
                  color: "red"
                });
              });
    }

    getCellars() {
      this.cellarsLoading = true;
      return CellarsRequests.fetchAll("per_page=25&page=1")
              .then((response: any) => {
                this.cellarsLoading = false;
                this.cellarsList = response.data;
              })
              .catch((error: Error) => {
                this.cellarsLoading = false;
                this.$store.dispatch("app/setSnackbarMessage", {
                  message: error,
                  color: "red"
                });
              });
    }

    async nearMeClicked() {
      try {
        const loc = await UtilitiesFunctions.getLocation();
        await this.$router.replace({
          name: 'experiences',
          query: { lat: loc.coords.latitude.toString(), lng: loc.coords.longitude.toString() }
        });
      } catch (e) {
        await this.$store.dispatch("app/setSnackbarMessage", {
          message: e.message,
          color: "red"
        });
      }
    }
  }
